import React from "react";
import ProfilKerjaSamaInternasionalContent from "../../components/layouts/kerja-sama-internasional/ProfilKerjaSamaInternasionalContent";

const ProfilKerjaSamaInternasional: React.FC = () => {
  return <ProfilKerjaSamaInternasionalContent />;
};

export default ProfilKerjaSamaInternasional;
